
import { NoseurObject } from "@rivtn/noseur";
import { PloutousBaseService, PloutousTrail } from "./PloutousBaseService";

export interface ITransactionAcknowledgement {
    status: number;
    amount: number;
    external_id: string;
    transaction_id: string;
    trails: PloutousTrail[];
}

export interface IManagedITransactionAcknowledgement {
    url: string;
}

export class TransactionAcknowledgementService extends PloutousBaseService {

    protected static instance: TransactionAcknowledgementService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!TransactionAcknowledgementService.instance) TransactionAcknowledgementService.instance = new TransactionAcknowledgementService();
        return TransactionAcknowledgementService.instance;
    }

    queryTransactionAcknowledgements(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/api/v1/transaction/acknowledgement", { query: this.normalizeParams(params) }));
    }

    acknowledge(params: any): Promise<any> {
        return this.report(this.transport.post("/api/v1/transaction/acknowledge", params));
    }

}
